import React from 'react';
import PropTypes from 'prop-types';
import IconContainer from './icon_container';

export default function TaskCardIcon(props) {
  return (
    <IconContainer viewBox="0 0 46 46" {...props}>
      <g transform="translate(1 1)" fill="none" fillRule="evenodd">
        <circle strokeWidth="1.1" cx="22" cy="22" r="22" className={cnSuffix(props.className, 'circle')} />
        <path
          d="M18.947 29.7c-.165 0-.33 0-.495-.166l-6.105-5.81c-.33-.333-.33-.832 0-1.164.33-.332.825-.332 1.155 0l5.61 5.314L30.498 16.75c.33-.333.824-.333 1.154 0 .33.33.33.83 0 1.16l-11.88 11.624c-.33.166-.66.166-.825.166"
          className={cnSuffix(props.className, 'path')}
        />
      </g>
    </IconContainer>
  );
}

function cnSuffix(className, suffix) {
  return className
    .split(/\s+/)
    .map(name => `${name}-${suffix}`)
    .join(' ');
}

TaskCardIcon.propTypes = {
  className: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/task_card_icon.jsx